import React from "react";
import WorkOrderList from "../../views/WorkOrder/WorkOrderList";

const WorkOrderPage = () => {
  return <WorkOrderList />;
};

export default WorkOrderPage;
